import { render } from "./WorkspaceView.vue?vue&type=template&id=16b8461e&scoped=true"
import script from "./WorkspaceView.vue?vue&type=script&lang=js"
export * from "./WorkspaceView.vue?vue&type=script&lang=js"

import "./WorkspaceView.vue?vue&type=style&index=0&id=16b8461e&scoped=true&lang=css"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b8461e"]])

export default __exports__